import React, { useEffect, useMemo, useRef, useState } from "react";
import { io } from "socket.io-client";
import qr from "../../../assests/tenant/images/qr.jpg";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import {
  useCountAllsupportQueriesMutation,
  useFetchAllsupportQueriesMutation,
  useUpdateSupportQueriesByIdMutation,
  useGetAllUnreadCountsMutation,
} from "../../../features/tenant/supportQueries/supportQueriesApi";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import ExportCSV from "../../../components/ExportCsv/ExportCsv";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import toast from "react-hot-toast";
import CustomExport from "../../../components/CustomExport/CustomExport";
import SupportChat from "../../../components/Tenant/SupportChat/SupportChat";

const queriesType = [
  {
    name: "All",
    id: null,
  },
  { id: 1, name: "KYC Related" },
  { id: 2, name: "Points Related" },
  { id: 3, name: "Redeemption Related" },
  { id: 4, name: "Application Related" },
  { id: 5, name: "Product Related" },
  { id: 6, name: "Qr Code Related" },
  { id: 7, name: "Others" },
];

const closingReasonsList = [
  { id: 1, name: "Resolved" },
  { id: 2, name: "Duplicate Query" },
  { id: 3, name: "User Not Responding" },
  { id: 4, name: "Invalid Query/Spam" },
  { id: 5, name: "Technical Bug Fixed" },
  { id: 6, name: "Others" }
];

const SupportQueries = () => {
  const { zone_id: zoneId, zone_name: zoneName } = getLoginUserData();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const currentDate = new Date().toISOString().split("T")[0];
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState(appUserTypes);

  const [myList, setMyList] = useState([])
  const [totalRows, setTotalRows] = useState(0);

  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chatRow, setChatRow] = useState(null);      // which query is chat open for
  const [unreadCounts, setUnreadCounts] = useState({});  // { [support_query_id]: count }

  const [remarks, setRemarks] = useState("");
  const [closingReason, setClosingReason] = useState({ id: null, name: "Select Reason" });

  const [selectedRow, setSelectedRow] = useState(null);

  const initialRequest = {
    type: "",
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    mobile: "",
    startDate: "",
    endDate:"",
  };
  const [request, setRequest] = useState(initialRequest);

  const [
    fetchAllsupportQueries,
    {
      data: allsupportQueriesData,
      isLoading: allsupportQueriesIsLoading,
      isError: allsupportQueriesIsError,
      error: allsupportQueriesError,
    },
  ] = useFetchAllsupportQueriesMutation();

  const [
    countAllsupportQueries,
    {
      data: countallsupportQueriesData,
      isLoading: countallsupportQueriesIsLoading,
      isError: countallsupportQueriesIsError,
      error: countallsupportQueriesError,
    },
  ] = useCountAllsupportQueriesMutation();

  const [
    fetchAllsupportQueriesCsv,
    {
      data: allsupportQueriesCsvData,
      isLoading: allsupportQueriesCsvIsLoading,
      isError: allsupportQueriesCsvIsError,
      error: allsupportQueriesCsvError,
    },
  ] = useFetchAllsupportQueriesMutation();

  const [
    updateSupportQueriesById,
    {
      data: allupdateSupportQueriesByIdvData,
      isLoading: allupdateSupportQueriesByIdvIsLoading,
      isError: allupdateSupportQueriesByIdvIsError,
      error: allupdateSupportQueriesByIdvError,
    },
  ] = useUpdateSupportQueriesByIdMutation();

  const [getAllUnreadCounts] = useGetAllUnreadCountsMutation();

  const loadUnreadCounts = () => {
    getAllUnreadCounts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    }).then((res) => {
      if (res?.data?.body?.unread_counts) {
        setUnreadCounts(res.data.body.unread_counts);
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedRow?.status !== "C") {
      // Closing a ticket — require closing reason
      if (!closingReason || !closingReason.id) {
        toast.error("Please select a closing reason");
        return;
      }
    } else {
      // Re-opening a ticket — require remarks
      if (!remarks || remarks.trim().length === 0) {
        toast.error("Remarks cannot be empty for reopening");
        return;
      }
    }
    
    handleUpdateStatus(selectedRow, remarks, closingReason?.name);
    setShowModal(false);
  }

  const handleUpdateStatus = (row, remarks, reason) => {
    if (row.status !== "C") {
      // Close the ticket
      updateSupportQueriesById({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: { status: "C", remarks: remarks, closing_reason: reason },
        id: row.id,
      });
    } else {
      // Re-open the ticket
      updateSupportQueriesById({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: { status: "P", remarks: remarks, closing_reason: null },
        id: row.id,
      });
    }
  };

  const handleShowModal = (row) => {
    setSelectedRow(row);
    setRemarks("");
    setClosingReason({ id: null, name: "Select Reason" });
    setShowModal(true);
  }

  useEffect(() => {
    if (allupdateSupportQueriesByIdvData) {
      fetchAllSupportQueriesFun();
    }
  }, [allupdateSupportQueriesByIdvData]);

  // Load unread counts on mount and after list refresh
  useEffect(() => {
    loadUnreadCounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Real-time socket notifications for new messages ─────────────────────────
  const notifySocketRef = useRef(null);
  const notifySoundRef = useRef(null);

  useEffect(() => {
    // Request browser notification permission on mount
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }

    // Create a reusable audio element for notification sounds
    // Using a simple data URI beep so no external file is needed
    notifySoundRef.current = new Audio(
      "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACA" +
      "f39/f4B/f3+Af39/gH9/f4B/f39/gH9/gH9/f4B/f3+Af39/f4B/f4B/f39/gIB/f39/gICA" +
      "f4CAgIB/gICAgICAgICBgYGBgoKBgoKCgoODg4OEhISEhYWFhYaGhoeHh4eIiIiJiYmKioqL" +
      "i4uMjIyNjY2Ojo6Pj4+QkJCRkZGSkpKTk5OUlJSVlZWWlpaXl5eYmJiZmZmampqbm5ucnJyd" +
      "nZ2enp6fn5+goKChoaGioqKjo6OkpKSlpaWmpqanp6eoqKipqamqqqqrq6usrKytra2urq6vr6+w" +
      "sLCxsbGysrKzs7O0tLS1tbW2tra3t7e4uLi5ubm6urq7u7u8vLy9vb2+vr6/v7/AwMDBwcHCwsLD" +
      "w8PExMTFxcXGxsbHx8fIyMjJycnKysrLy8vMzMzNzc3Ozs7Pz8/Q0NDR0dHS0tLT09PU1NTV1dXW" +
      "1tbX19fY2NjZ2dna2trb29vc3Nzd3d3e3t7f39/g4ODh4eHi4uLj4+Pk5OTl5eXm5ubn5+fo6Ojp" +
      "6enq6urr6+vs7Ozt7e3u7u7v7+/w8PDx8fHy8vLz8/P09PT19fX29vb39/f4+Pj5+fn6+vr7+/v8" +
      "/Pz9/f3+/v7//wAA"
    );
    notifySoundRef.current.volume = 0.4;

    // Connect to the support-chat socket namespace
    const baseUrl = (process.env.REACT_APP_BASE_URL || "http://localhost:5000").replace(/\/api\/?$/, "");
    const token = sessionStorage.getItem("access_token");
    const tenantId = JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id;

    const socket = io(`${baseUrl}/support-chat`, {
      auth: { token, slug: tenantId },
      transports: ["websocket", "polling"],
      reconnectionAttempts: 10,
      reconnectionDelay: 3000,
    });

    notifySocketRef.current = socket;

    socket.on("connect", () => {
      console.info("[SupportQueries] Notification socket connected");
    });

    // Listen for new message notifications across ALL queries
    socket.on("chat:tenant_notify", (data) => {
      const { support_query_id, sender_name, sender_type, message, attachment_type } = data;

      // Only notify for messages FROM app users (not our own tenant messages)
      if (sender_type !== "app_user") return;

      // Don't notify if the chat panel for this query is already open
      // (the SupportChat component handles its own in-chat display)
      // We still update the badge though
      const isChatOpenForQuery = chatRow?.id === support_query_id;

      // Update unread count badge
      setUnreadCounts((prev) => ({
        ...prev,
        [support_query_id]: (prev[support_query_id] || 0) + 1,
      }));

      if (!isChatOpenForQuery) {
        // Construct notification body
        let body = message || "";
        if (attachment_type === "image") body = "📷 Sent an image" + (message ? `: ${message}` : "");
        if (attachment_type === "pdf") body = "📄 Sent a document" + (message ? `: ${message}` : "");

        // Play notification sound
        try {
          notifySoundRef.current?.play().catch(() => {});
        } catch (e) {}

        // Show toast in the app
        toast(`💬 ${sender_name}: ${body}`, {
          duration: 4000,
          icon: "🔔",
          style: { background: "#1e3a8a", color: "#fff", fontWeight: 500, fontSize: 13 },
        });

        // Show browser notification when tab is not focused
        if (document.hidden && "Notification" in window && Notification.permission === "granted") {
          const notif = new Notification("New Support Message", {
            body: `${sender_name}: ${body}`,
            tag: `support-chat-${support_query_id}`, // prevents duplicate notifications per query
          });
          // Auto-close after 5 seconds
          setTimeout(() => notif.close(), 5000);
        }
      }
    });

    socket.on("chat:tenant_status_update", (data) => {
      const { support_query_id, status, closing_reason } = data;
      setMyList((prevList) =>
        prevList.map((item) =>
          item.id === support_query_id ? { ...item, status, closing_reason } : item
        )
      );
    });

    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatRow]);
  const fetchAllSupportQueriesFun = () => {
    fetchAllsupportQueries({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const countAllSupportQueriesFun = () => {
    countAllsupportQueries({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchAllSupportQueriesCsvFun = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchAllsupportQueriesCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };

  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (allsupportQueriesCsvData && allsupportQueriesCsvData.body.supportQueriesList) {
      setCsvData(allsupportQueriesCsvData.body.supportQueriesList);
    }

    if (allupdateSupportQueriesByIdvError) {
      setCsvData(null);
    }
  }, [allsupportQueriesCsvData, allupdateSupportQueriesByIdvError])

  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element.user_type.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "User Type",
      cell: (row) => row.user_type,
      sortable: true,
    },
    {
      name: "Type",
      cell: (row) => row.type,
      sortable: true,
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
    },

    {
      name: "Short Desc",
      cell: (row) => row?.short_description,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Long Desc",
      cell: (row) => row?.long_description,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Remarks",
      cell: (row) => row?.remarks,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Closing Reason",
      cell: (row) => row?.closing_reason || "-",
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "Image",
      cell: (row) => (
        <div className="w-12 h-12 my-2 rounded-full">
          {row.images && row.images[0] ? ( // Check if row.images exists and has at least one element
            <img
              src={row.images[0]}
              alt={row.images[0]}
              className="rounded-full"
              onClick={() =>
                setShowImageModal(
                  row.images[0]
                )
              }
            />
          ) : (
            <span>No Image</span> // Display a message or placeholder for no image
          )}
        </div>
      ),
    },
    {
      name: "Status",
      cell: (r) => {
        const statusMap = {
          P: { label: "Pending", className: "btn btn-outline-warning btn-sm" },
          I: { label: "In Progress", className: "btn btn-outline-primary btn-sm" },
          C: { label: "Closed", className: "btn btn-outline-secondary btn-sm" },
        };
        const st = statusMap[r.status] || statusMap["P"];
        return (
          <button
            className={st.className}
            onClick={() => handleShowModal(r)}
          >
            {st.label}
          </button>
        );
      },
      ignoreRowClick: true,
      button: true,
    },

    {
      name: "Chat",
      cell: (row) => {
        const unread = unreadCounts[row.id] || 0;
        return (
          <button
            className="btn btn-outline-primary btn-sm"
            style={{ position: "relative", whiteSpace: "nowrap" }}
            onClick={() => {
              setChatRow(row);
              // Clear unread badge locally on open
              setUnreadCounts((prev) => ({ ...prev, [row.id]: 0 }));
            }}
          >
            💬 Chat
            {unread > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: -6,
                  right: -6,
                  background: "#ef4444",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 18,
                  height: 18,
                  fontSize: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  lineHeight: 1,
                }}
              >
                {unread > 9 ? "9+" : unread}
              </span>
            )}
          </button>
        );
      },
      ignoreRowClick: true,
      button: true,
      minWidth: "100px",
    },
    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
      minWidth: "200px",
    },
  ];

  useEffect(() => {
    fetchAllSupportQueriesFun();
    countAllSupportQueriesFun();
    // fetchAllSupportQueriesCsvFun();
  }, [limit, offset, request]);
  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };

  const clearFilters = () => {
    setRequest(initialRequest);
  };

  // console.log(
  //   "allsupportQueriesCsvData?.body?.supportQueriesList",
  //   allsupportQueriesCsvData?.body
  // );

  useEffect(() => {
    if (allsupportQueriesData && allsupportQueriesData.body && allsupportQueriesData.body.supportQueriesList) {
      setMyList(allsupportQueriesData.body.supportQueriesList)
    }
  }, [allsupportQueriesData])

  useEffect(() => {
    if (countallsupportQueriesData &&
      countallsupportQueriesData.body.total_support_queries) {
      setTotalRows(countallsupportQueriesData.body.total_support_queries)
    }
  }, [countallsupportQueriesData])


  return (
    <div className="flex w-full bg-gray-200 h-full justify-center">
      <div className="w-full ">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Support Queries
          <LinksComponent />
        </div>

        <div className="p-3">
          <div className="flex justify-between items-start">
            {/* {allsupportQueriesCsvData &&
              allsupportQueriesCsvData?.body?.supportQueriesList && (
                <ExportCSV
                  data={
                    allsupportQueriesCsvData &&
                    allsupportQueriesCsvData?.body?.supportQueriesList
                  }
                  columnsToExport={[
                    "user_type",
                    "name",
                    "type",
                    "mobile",
                    "short_description",
                    "long_description",
                    "remarks",
                  ]}
                />
              )} */}

            <div className="mb-2">
              <CustomExport fetchData={fetchAllSupportQueriesCsvFun} data={csvData} defaultColumnExport={[
                "user_type",
                "name",
                "type",
                "mobile",
                "short_description",
                "long_description",
                "remarks",
                "closing_reason",
              ]}
                filename="support_queries"
              />
            </div>
          </div>
          {/* <div className="">
            <button
              type="submit"
              className="btn btn-outline-primary clear-both px-3 py-2.5  mb-2"
            >
              Export
            </button>
          </div> */}
          <div className=" bg-white shadow rounded-lg ">
            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
              <div className="flex opt_w100 space-x-2 ">
                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder=""
                    value={request.startDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder=""
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 ">
                  <div className="flex-col slc_dvd topslt">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">User Types</label>
                    <div className="relative searchin">
                      {appUsers && appUsers.length > 0 && (
                        <SelectComponent
                          className="capitalize"
                          //title={"User Types"}
                          selected={userTypesArray}
                          setSelected={setUserTypesArray}
                          dataArr={appUsers}
                        />
                      )}</div>
                  </div>
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Query Type
                  </label>
                  <div className="mb-2 flex-col slc_dvd">
                    <select
                      className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 "
                      name="type"
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, type: newValue };
                        });
                      }}
                      id="type"
                      value={request.type}
                    >
                      {queriesType &&
                        queriesType.length > 0 &&
                        queriesType.map((each) => (
                          <option key={each.id} value={each.name}>
                            {each.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="w-52 ">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="text"
                    className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                    placeholder="Enter Mobile No"
                    value={request.mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          mobile: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="">
                  <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    &nbsp;
                  </label>

                  <div className="flex flex-row  gap-2 ">
                    <div className="relative searchin">
                      <button
                        className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                        onClick={() => {
                          fetchAllSupportQueriesFun();
                          // fetchAllSupportQueriesCsvFun();
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="relative searchin">
                      <button
                        className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                        onClick={() => {
                          clearFilters();
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className=" p-3">
              <DataTableComponent
              keyField={(row) => row.SNo}
                columns={columns}
                data={
                  myList
                }
                totalRows={
                  totalRows
                }
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
            </div>
          </div>
        </div>
        {showModal && (
          <ModalComponent
            size={"md"}
            data={"nadnandand"}
            show={showModal}
            setShow={setShowModal}
          >
            <div className="w-full p-4 bg-white rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 border-b pb-2">
                {selectedRow?.status !== "C" ? "Close Support Query" : "Re-open Support Query"}
              </h3>
              <div className="w-full flex flex-col space-y-4">
                {selectedRow?.status !== "C" && (
                  <div className="w-full relative z-[100]">
                    <SelectComponent
                      title={"Closing Reason"}
                      selected={closingReason}
                      setSelected={setClosingReason}
                      dataArr={closingReasonsList}
                      required={true}
                    />
                  </div>
                )}
                <div className="w-full">
                  <InputComponent
                    name={selectedRow?.status !== "C" ? "Closing Remarks" : "Re-open Remarks"}
                    type={"textarea"}
                    value={remarks}
                    placeholder={selectedRow?.status !== "C" ? "Enter details/notes for closing this query..." : "Enter reason for re-opening this query..."}
                    setValue={setRemarks}
                    required={selectedRow?.status === "C"}
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6 border-t pt-4">
                <button
                  type="button"
                  className="text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium rounded-lg text-sm px-4 py-2 text-center"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`text-white font-medium rounded-lg text-sm px-4 py-2 text-center ${
                    selectedRow?.status !== "C"
                      ? "bg-red-600 hover:bg-red-700 focus:ring-4 focus:ring-red-200"
                      : "bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-200"
                  }`}
                  onClick={(e) => handleSubmit(e)}
                >
                  {selectedRow?.status !== "C" ? "Close Query" : "Re-open Query"}
                </button>
              </div>
            </div>
          </ModalComponent>
        )}
        {showImageModal && (
          <ImageModal
            show={showImageModal ? true : false}
            setShow={setShowImageModal}
            size="md"
            data={showImageModal}
          >
            <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
              <img
                src={showImageModal}
                className="h-full w-full object-cover object-center group-hover:opacity-75"
              />
            </div>
          </ImageModal>
        )}

        {/* 1v1 Chat Panel */}
        {chatRow && (
          <SupportChat
            queryId={chatRow.id}
            queryInfo={chatRow}
            onClose={() => {
              setChatRow(null);
              // Refresh unread counts after closing
              loadUnreadCounts();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SupportQueries;
